// IE 11 Polyfills
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import CKEditor from 'ckeditor4-react';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initIcxPortal } from './core/utils/IcxPortal';

// To load all features for the Rich Text Editor
// We avoid using CKEditor CDN by serving it's code from our server (from public folder)
CKEditor.editorUrl = 'ckeditor_4.24.0-lts/ckeditor.js';

// Initialize ICX Portal integration
initIcxPortal(() => ReactDOM.render(<App />, document.getElementById('root')));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
